interface Config {
  REACT_APP_BASEURL: string;
  REACT_APP_BACKEND_URL?: string;
  AUTH0_NAMESPACE: string;
}

// Read from window.__ENV__ (generated at build) first, then fall back to process.env

const hasWindow = typeof window !== 'undefined';
const runtimeEnv = (hasWindow && (window as any).__ENV__) || {};
const runtimeOrigin = hasWindow ? window.location.origin : undefined;

export const config: Config = {
  REACT_APP_BASEURL:
    (runtimeEnv.REACT_APP_BASEURL as string) ||
    (process.env.REACT_APP_BASEURL as string) ||
    (runtimeOrigin as string),
  REACT_APP_BACKEND_URL:
    (runtimeEnv.REACT_APP_BACKEND_URL as string) ||
    (process.env.REACT_APP_BACKEND_URL as string),
  AUTH0_NAMESPACE:
    (runtimeEnv.REACT_APP_AUTH0_NAMESPACE as string) ||
    (process.env.REACT_APP_AUTH0_NAMESPACE as string) ||
    'https://ferritico.com',
};

export default config;

// API base used by fetch requests:
// - If REACT_APP_BACKEND_URL is provided at runtime, normalize it to include /api
// - Otherwise fall back to '/api' which is expected to be proxied in dev
export const API_BASE = (() => {
  const raw = config.REACT_APP_BACKEND_URL || '';
  if (!raw) return '/api';
  try {
    const u = new URL(raw);
    const path = u.pathname || '/';
    const normalized = path.endsWith('/') ? path.slice(0, -1) : path;
    if (normalized === '' || normalized === '/') {
      u.pathname = '/api';
    } else if (!normalized.startsWith('/api')) {
      u.pathname = '/api' + (normalized.startsWith('/') ? normalized : '/' + normalized);
    }
    return u.toString().replace(/\/$/, '');
  } catch {
    const trimmed = raw.replace(/\/$/, '');
    return trimmed + '/api';
  }
})();
